interface ValidationMessageProps {
  message: string | null
  type?: 'error' | 'warning' | 'info'
  className?: string
}

export default function ValidationMessage({
  message,
  type = 'error',
  className = ''
}: ValidationMessageProps) {
  if (!message) return null

  const getColor = () => {
    switch (type) {
      case 'error': return 'var(--accent-red)'
      case 'warning': return '#ffa726'
      case 'info': return 'var(--primary-blue)'
      default: return 'var(--accent-red)'
    }
  }

  const getIcon = () => {
    switch (type) {
      case 'error': return '❌'
      case 'warning': return '⚠️'
      case 'info': return 'ℹ️'
      default: return '❌'
    }
  }

  return (
    <div className={`validation-message ${className}`} style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      color: getColor(),
      fontSize: '0.875rem',
      marginTop: '0.25rem',
      lineHeight: 1.3
    }}>
      <span style={{ fontSize: '0.75rem' }}>
        {getIcon()}
      </span>
      <span>{message}</span>
    </div>
  )
}